import { BlockEmptyView } from 'src/editor/component/block-empty-view';
import { judgeSharePage } from 'src/utils/getPageId';
import type { BlockElement } from '../core/type';
import { BlockDrop } from './dnd/block-drop';
import { useAppTranslation } from '@flowus/common/i18n/use-translation';

export const AdBlockElement: BlockElement = ({ id, root }) => {
  const isShare = judgeSharePage();
  const { t } = useAppTranslation();
  if (isShare) return null;
  return (
    <BlockDrop id={id} className="py-1 my-px w-full pr-2" horizontal={root}>
      <BlockEmptyView
        readonly={true}
        onClick={() => {}}
        iconProp={{ name: 'IcUploadBookmark', size: 'normal' }}
        text={t('components.editor.ad_block.description')}
        className="cursor-default"
      />
    </BlockDrop>
  );
};
